// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"591":"87cf3f47","787":"61db89d1"}[chunkId] + ".chunk.js";
};